import {
  Show,
  SimpleShowLayout,
  NumberField,
  FunctionField,
} from "react-admin";
import { StatusChip } from "../../../../components/StatusChip";
import { CopyableField, DateTimeField } from "../../../../shared/fields";

export const BetShow = () => (
  <Show>
    <SimpleShowLayout>
      <CopyableField source="betId" label="Bet ID" sortable={false} />
      <CopyableField source="roundId" label="Round ID" sortable={false} />
      <CopyableField source="operatorId" label="Operator ID" sortable={false} />
      <CopyableField source="userId" label="User ID" sortable={false} />
      <CopyableField source="username" label="Username" sortable={false} />
      <CopyableField
        source="operatorSessionId"
        label="Session ID"
        sortable={false}
      />
      <NumberField source="slot" label="Slot" />
      <FunctionField
        label="Status"
        render={(r: { status?: string }) => <StatusChip value={r?.status} />}
      />
      <NumberField source="betAmount" label="Bet Amount" />
      <NumberField source="payoutMultiplier" label="Payout Multiplier" />
      <NumberField source="payoutAmount" label="Payout Amount" />
      <NumberField source="autoCashoutMultiplier" label="Auto Cashout x" />
      <CopyableField
        source="walletTransactionId"
        label="Wallet Tx ID"
        sortable={false}
      />
      <DateTimeField source="createdAt" label="Created" />
      <DateTimeField source="updatedAt" label="Updated" />
    </SimpleShowLayout>
  </Show>
);
